import { Custom } from "components";
import { useApp } from "context";
import { useForm } from "hooks";
import { Enums, Helpers } from "utils";
import { Box } from "@mui/material";

type Props = {
  users: number[];
  onSubmit?: () => void;
};

export const Reminder = (props: Props) => {
  const { t, theme, setFeedback, service } = useApp();

  const initialState = {
    message: "",
  };

  const { onChange, onSubmit, values } = useForm(submitCallback, initialState);

  async function submitCallback() {
    const { message }: any = values;
    if (Helpers.hasValue(message)) {
      const confirmSubmit = window.confirm(
        `Are you sure you want to send a reminder to ${props.users.length} patients?`
      );
      if (confirmSubmit) {
        const [status, response] = await service.broadcast.reminder(
          message,
          props.users
        );
        if (status === Enums.EnumResponse.Success) {
          setFeedback(null);
          props.onSubmit && props.onSubmit();
        }
      }
    }
  }

  return (
    <form onSubmit={onSubmit} className="qh-form">
      <Custom.TextField
        name="message"
        required={true}
        multiline={true}
        onChange={onChange}
        label={t.label.message}
      />
      <br />
      <Box
        display="flex"
        justifyContent="flex-end"
        marginTop={theme.margin.sm}
        className="qh-control"
      >
        <Custom.Button submit>{t.action.submit}</Custom.Button>
      </Box>
    </form>
  );
};
